// Add this as a separate script file or in theme.liquid
// Make sure to load cart-return-button.css BEFORE this script
(function() {  
  // Check on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndShowReturnButton);
  } else {
    checkAndShowReturnButton();
  }
  
  // Also check periodically (every 2 seconds)
  const checkInterval = setInterval(() => {
    if (checkAndShowReturnButton()) {
      clearInterval(checkInterval);
    }
  }, 2000);
  
  // Check when page becomes visible
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      checkAndShowReturnButton();
    }
  });

  function checkAndShowReturnButton() {
    const returnUrl = sessionStorage.getItem('return_to_product');
    const captchaDetected = sessionStorage.getItem('captcha_challenge_detected');
    
    if (!returnUrl || !captchaDetected) {
      return false;
    }
    
    if (window.location.pathname !== '/cart') {
      return false;
    }
    
    // Check if button already exists
    if (document.querySelector('[data-return-btn]')) {
      return true;
    }
    
    createReturnButton(returnUrl);
    return true;
  }

  function createReturnButton(returnUrl) {
    // Create main container
    const container = document.createElement('div');
    container.setAttribute('data-return-btn', 'true');
    
    // Icon
    const icon = document.createElement('div');
    icon.className = 'return-icon';
    icon.textContent = '✅';
    container.appendChild(icon);
    
    // Title
    const title = document.createElement('h3');
    title.textContent = 'Security Verified!';
    container.appendChild(title);
    
    // Message
    const message = document.createElement('p');
    message.textContent = 'Your security verification is complete. Click below to return to the product page.';
    container.appendChild(message);
    
    // Button container
    const buttonContainer = document.createElement('div');
    buttonContainer.className = 'button-container';
    
    // Return Button
    const button = document.createElement('button');
    button.className = 'return-button';
    button.textContent = '← Back to Product';
    
    button.onclick = (e) => {
      e.preventDefault();
      
      button.disabled = true;
      button.textContent = 'Redirecting...';
      
      // Clear data
      sessionStorage.removeItem('return_to_product');
      sessionStorage.removeItem('captcha_challenge_detected');
      
      // Redirect
      setTimeout(() => {
        window.location.href = returnUrl;
      }, 800);
    };
    
    buttonContainer.appendChild(button);
    
    // Close Button
    const closeButton = document.createElement('button');
    closeButton.className = 'close-button';
    closeButton.textContent = '✕';
    
    closeButton.onclick = (e) => {
      e.preventDefault();
      
      // Remove container with animation
      container.style.animation = 'slideDown 0.4s ease-out forwards';
      
      setTimeout(() => {
        container.remove();
      }, 400);
    };
    
    buttonContainer.appendChild(closeButton);
    container.appendChild(buttonContainer);
    document.body.appendChild(container);
  }
})();
// end

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      setTimeout(() => {
        removeExpressDeliveryAttribute();
        removeShipIfLessThanTwo();
      }, 1000);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    document.addEventListener("DOMContentLoaded", () => {
    this.checkAndRemoveOrphanUpsells();
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    if(event.target.closest('cart-upsell')) return
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId, event.target);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'main-sub-cartfooter',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart__blocks-totals',
      },
      {
        id: 'main-cart-footer-inner',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.cart__footer'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
    ];
  }


  updateQuantity(line, quantity, name, variantId, targetElement_) {

    let drawer = this.querySelector('#CartDrawer-CartItems')
    let formData = new FormData();
    let intendedProduct;

    if(drawer) {
      intendedProduct = drawer.querySelector(`#CartDrawer-Item-${line}`)
    } else {
      intendedProduct = this.querySelector(`#main-cart-items #CartItem-${line}`)
    }

    let checkUpsell=  intendedProduct.querySelector(`.cart-item__details .product-option[data-property-first="_ref_id"]`)

    let targetElmInput;
    if(targetElement_) {
      targetElmInput = targetElement_?.classList.contains('quantity__input')
    } else {
      targetElmInput = !targetElement_?.classList.contains('quantity__input')
    }
    
    if(checkUpsell && intendedProduct.querySelector('[js-main-product]') && targetElmInput) {
      let ref_id_ = intendedProduct.querySelector('.cart-item__details .product-option[data-property-first="_ref_id"]').getAttribute('data-property-last')
      let availableSameRef = this.querySelectorAll(`.cart-item__details .product-option[data-property-first="_ref_id"][data-property-last='${ref_id_}']`)

      availableSameRef.forEach(el => {
        let elm_ = el.closest('[js-cart-item-details]')
        formData.append(`updates[${elm_.dataset.lineItemKey}]`,quantity)
      })
    } else {
      formData.append(`updates[${intendedProduct.querySelector('[js-cart-item-details]').dataset.lineItemKey}]`,quantity)

    }
 
    formData.append('sections',this.getSectionsToRender().map((section) => section.section))
    formData.append('sections_url', window.location.pathname)


    this.enableLoading(line);

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    config.body = formData

    fetch(`${routes.cart_update_url}`, config)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');
       
        if (parsedState.message) {
          const errorMessage = "The requested qty is not available";
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, errorMessage);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        
        // update cart title number
        const titleCount = document.querySelector('.cart-wrapper .title--primary b');
        if (titleCount && parsedState.item_count !== undefined) {
          titleCount.textContent = `(${parsedState.item_count})`;
        }
        
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
        attachEventDatePickerListener();
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
}
 
  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  // ✅ New Method: Automatically Remove Upsell Without Main Product
  checkAndRemoveOrphanUpsells() {
    const cartItems = this.querySelectorAll('[js-cart-item-details]');
    const mainProductRefIds = new Set();

    // Collect _ref_id from all main products
    cartItems.forEach(item => {
      const isMain = item.querySelector('[js-main-product]');
      const refEl = item.querySelector('.product-option[data-property-first="_ref_id"]');
      if (isMain && refEl) {
        mainProductRefIds.add(refEl.getAttribute('data-property-last'));
      }
    });

    // Remove upsell items if their main product is missing
    cartItems.forEach(item => {
      const isMain = item.querySelector('[js-main-product]');
      const refEl = item.querySelector('.product-option[data-property-first="_ref_id"]');

      if (!isMain && refEl) {
        const refId = refEl.getAttribute('data-property-last');
        const lineItemKey = item.dataset.lineItemKey;

        if (!mainProductRefIds.has(refId)) {
          const formData = new FormData();
          formData.append(`updates[${lineItemKey}]`, 0);
          formData.append('sections_url', window.location.pathname);

          fetch(`${routes.cart_update_url}`, {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          }).then(() => this.onCartUpdate());
        }
      }
    });
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

function addBusinessDaysCart(originalDate, numDaysToAdd) {
  const Sunday = 0;
  const Saturday = 6;
  let daysRemaining = numDaysToAdd;

  const newDate = originalDate.clone();
  while (daysRemaining > 0) {
    newDate.add(1, 'days');
    if (newDate.day() !== Sunday && newDate.day() !== Saturday) {
      daysRemaining--;
    }
  }
  return newDate;
}

function addExpressDaysCart(originalDate, extraDays) {
  const Sunday = 0;
  const Saturday = 6;
  let daysRemaining = extraDays;
  console.log('extraDays',extraDays)
  const newDate = originalDate.clone();
  let firstWeekendSkipped = false;
  
  while (daysRemaining > 0) {
    // console.log('daysRemaining', daysRemaining)
    const day = newDate.day();
    if (!firstWeekendSkipped && (day === Saturday || day === Sunday)) {
      console.log('day === Saturday',day === Saturday)
      console.log('day === Sunday',day === Sunday)
      // Skip first weekend
      newDate.add(1, 'days');
      if (day === Sunday) {
        firstWeekendSkipped = true; // mark first weekend skipped
      }
      continue;
    }
    // Count day
    daysRemaining--;
    newDate.add(1, 'days');
  }
  // After counting all days, ensure first weekend is skipped if it hasn't been yet
  while (!firstWeekendSkipped && (newDate.day() === Saturday || newDate.day() === Sunday)) {
    if (newDate.day() === Sunday) firstWeekendSkipped = true;
    newDate.add(1, 'days');
  }
  return newDate;
}

function updateCartEstimatedDeliverySequentially(items, index = 0, deliveryUpdated = false) {
  if (index >= items.length) {
    if (deliveryUpdated) {
      window.location.reload();
    }
    return Promise.resolve();
  }

  const item = items[index];
  const itemRows = document.querySelectorAll(`[data-line-item-key="${item.key}"]`);
  const itemRow = [...itemRows].find(el => el.dataset.inventory !== undefined);
  const rawInventory = itemRow?.dataset?.inventory ?? "0";
  const inventoryQty = parseInt(rawInventory || "0", 10);
  const variantDeliveryDays = itemRow.dataset.variantDeliveryDays;
  const isTwiningProduct = item.properties["_Twining product"];
  // Choose delivery days based on inventory
  let deliveryDays = parseInt(item.properties["_Delivery days"], 10);
  let deliveryType = `${item.properties["_Delivery type"]}`;
  console.log('deliveryDays 1',deliveryDays)
  if (inventoryQty <= 0) {
    if(!isTwiningProduct){
      deliveryDays = parseInt(variantDeliveryDays, 10) || parseInt(item.properties["_Delivery days mto"], 10) || deliveryDays;
    }
    // console.log('deliveryDays 2',deliveryDays)
    
    // deliveryType = isNaN(deliveryDays) ? "RTS" : "MTO";
    // console.log('colletionRrtsDays',colletionRrtsDays)
  }
  const colletionRrtsDays = parseInt(itemRow.dataset.colletionRtsDays);
  if (item.properties["_Product category"] != 'Saree') {
    if (colletionRrtsDays >= deliveryDays) {
      deliveryType =  "RTS"
    } else {
      deliveryType = "MTO"
    }
  }
  console.log('deliveryDays 3',deliveryDays)
  console.log('deliveryType',deliveryType)

  if (isNaN(deliveryDays)) {
    return updateCartEstimatedDeliverySequentially(items, index + 1, deliveryUpdated);
  }

  const extradeliverydays = document.querySelector('[extradeliverydays]').getAttribute('extradeliverydays');
  const originalDate = moment();
  // const testDate = originalDate.clone().add(1, 'days');
  const baseDays = deliveryDays + 1;
  let mtoRrtsDays = parseInt(itemRow.dataset.mtoRtsDays) + 1;
  if (item.properties["_Product category"] === 'Saree') {
    mtoRrtsDays = (deliveryDays || parseInt(itemRow.dataset.mtoRtsDays)) + 1;
  }
  
  let newEstimatedDelivery = addBusinessDaysCart(originalDate, baseDays).format("dddd, DD MMM YYYY");
  let newEstimatedExpressDelivery = ''
  let newEstimatedStandardDelivery = ''
  if (deliveryType == 'RTS') {
    newEstimatedExpressDelivery = addExpressDaysCart(originalDate, mtoRrtsDays).format("dddd, DD MMM YYYY");
    newEstimatedStandardDelivery = addExpressDaysCart(originalDate, mtoRrtsDays + parseInt(extradeliverydays)).format("dddd, DD MMM YYYY");
  } else {
    newEstimatedDelivery = addBusinessDaysCart(originalDate, baseDays).format("dddd, DD MMM YYYY");
  }
  
  const updatedProperties = { ...item.properties };
  let needsUpdate = false;
  if(!isTwiningProduct){
    if (item.properties["_Delivery type"] != deliveryType) {
      updatedProperties["_Delivery type"] = deliveryType;
      if (deliveryType == 'RTS') {
        delete updatedProperties["Estimated delivery"];
        updatedProperties["Priority express shipping"] = newEstimatedExpressDelivery;
        updatedProperties["Estimated standard delivery"] = newEstimatedStandardDelivery;
      } else {
        delete updatedProperties["Priority express shipping"];
        delete updatedProperties["Estimated standard delivery"];
        updatedProperties["Estimated delivery"] = newEstimatedDelivery;
      }
      needsUpdate = true;
    }
    if (item.properties["Estimated delivery"] !== undefined) {
      // console.log('newEstimatedDelivery', newEstimatedDelivery, deliveryType, testDate, deliveryDays)
      const currentEstimate = item.properties["Estimated delivery"].trim().toLowerCase();
      if (currentEstimate !== newEstimatedDelivery.trim().toLowerCase()) {
        updatedProperties["_Delivery type"] = deliveryType;
        if (deliveryType == 'RTS') {
          delete updatedProperties["Estimated delivery"];
          updatedProperties["Priority express shipping"] = newEstimatedExpressDelivery;
          updatedProperties["Estimated standard delivery"] = newEstimatedStandardDelivery;
        } else {
          updatedProperties["Estimated delivery"] = newEstimatedDelivery;
        }
        needsUpdate = true;
      }
    }

    if (item.properties["Priority express shipping"] !== undefined) {
      
      const currentExpress = item.properties["Priority express shipping"].trim().toLowerCase();
      if (currentExpress !== newEstimatedExpressDelivery.trim().toLowerCase()) {
        updatedProperties["_Delivery type"] = deliveryType;
        if (deliveryType == 'MTO') {
          delete updatedProperties["Priority express shipping"];
          updatedProperties["Estimated delivery"] = newEstimatedDelivery;
        } else {
          updatedProperties["Priority express shipping"] = newEstimatedExpressDelivery;
        }
        needsUpdate = true;
      }
    }

    if (item.properties["Estimated standard delivery"] !== undefined) {
      const currentStandard = item.properties["Estimated standard delivery"].trim().toLowerCase();
      if (currentStandard !== newEstimatedStandardDelivery.trim().toLowerCase()) {
        if (deliveryType == 'MTO') {
          delete updatedProperties["Estimated standard delivery"];
        } else {
          updatedProperties["Estimated standard delivery"] = newEstimatedStandardDelivery;
        }
        needsUpdate = true;
      }
    }
  }

  if (!needsUpdate) {
    return updateCartEstimatedDeliverySequentially(items, index + 1, deliveryUpdated);
  }

  return fetch(`/cart/change.js?timestamp=${new Date().getTime()}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: item.key,
      properties: updatedProperties
    })
  })
    .then(response => {
      if (!response.ok) throw new Error(`Error ${response.status}`);
      return response.json();
    })
    .then(() => fetch(`/cart.js?timestamp=${new Date().getTime()}`))
    .then(res => res.json())
    .then(refetchedCart => updateCartEstimatedDeliverySequentially(refetchedCart.items, index + 1, true))
    .catch(error => {
      console.error("Error updating cart:", error);
      return updateCartEstimatedDeliverySequentially(items, index + 1, deliveryUpdated);
    });
}


function updateCartEstimatedDelivery() {
  fetch(`/cart.js?timestamp=${new Date().getTime()}`)
    .then(res => res.json())
    .then(cart => updateCartEstimatedDeliverySequentially(cart.items))
    .catch(err => console.error("Error fetching cart:", err));
}

// 🔁 Call once on page load
updateCartEstimatedDelivery();

// If Product visibility No then product remove from the cart
document.addEventListener('DOMContentLoaded', async () => {
  const items = document.querySelectorAll('[js-cart-item-details]');
  const removals = [...items].map(el => {
    const { productVisibility: vis, lineItemKey: key } = el.dataset;
    return vis === 'No' && key
      ? fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        })
      : null;
  }).filter(Boolean);

  if (removals.length) {
    await Promise.all(removals);
    location.reload();
  }
});

async function removeExpressDeliveryAttribute() {
  try {
    const cart = await fetch('/cart.js?timestamp=' + new Date().getTime())
      .then(res => res.json());

    // Remove Express Delivery if any item missing Priority express shipping
    const hasExpressDeliveryItems = cart.items.some(item => item.properties["Priority express shipping"]);
    
    if (!hasExpressDeliveryItems && cart.attributes["Express Delivery"]) {
      // Remove the attribute
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { "Express Delivery": null } })
      });

      // Refresh cart UI
      const cartItemsEl = document.querySelector('cart-items');
      if (cartItemsEl) cartItemsEl.onCartUpdate();
    }
  } catch (err) {
    console.error('Error removing Express Delivery attribute:', err);
  }
}


// hide view details button in the cart page
document.querySelectorAll('#main-cart-items .cart-item__details').forEach(cartItem => {
  const lineItemKey = cartItem.getAttribute('data-line-item-key');
  const detailsId = `main-cart-details-${lineItemKey}`;
  
  const detailsEl = document.getElementById(detailsId);
  const viewDetailsBtn = cartItem.querySelector('#main-cart-items .view-details-btn');
  
  if (detailsEl && viewDetailsBtn) {
    const productOptions = detailsEl.querySelectorAll('#main-cart-items .product-option');
    const allHidden = Array.from(productOptions).every(opt => opt.classList.contains('hide'));

    if (allHidden) {
      viewDetailsBtn.classList.add('hidden');
    }
  }
});

(function(){
  const COOKIE = 'deliveryCheckboxState';
  const SHIP_PROP = 'Ship together date';
  const COOKIE_DISCOUNT = 'discount_code';
  const DISCOUNT = 'TEST12';
  const setCookie = (n,v,d=7)=>document.cookie=`${n}=${v}; max-age=${d*86400}; path=/`;
  const eraseCookie = n => document.cookie = `${n}=; Max-Age=0; path=/`;

  const fetchCart = ()=>fetch('/cart.js').then(r=>r.json());
  // const changeItem = (id,q,props)=>fetch('/cart/change.js',{
  //   method:'POST',
  //   headers:{'Content-Type':'application/json'},
  //   body:JSON.stringify({id,quantity:q,properties:props})
  // });
  async function changeItem(id,q,props) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body:JSON.stringify({id,quantity:q,properties:props}),
    }).then((r) => r.json());
  }

  function getCookie(name) {
    return document.cookie.split('; ').find(row => row.startsWith(name+'='))?.split('=')[1];
  }

  async function removeShipIfLessThanTwo() {
    const cart = await fetchCart();
    
    let hasGiftCard = false;
    for (const item of cart.items) {
      if (item.gift_card){
        hasGiftCard = true;
      }
    }
    async function removeShip() {
      for (const it of cart.items) {
        if (it.properties?.[SHIP_PROP]) {
          let p = {...it.properties};
          console.log('p', p)
          if (p["_Ship together"]) delete p["_Ship together"];
          if (p["Ship together date"]) delete p["Ship together date"];
          await changeItem(it.key, it.quantity, p);
          document.querySelector('.delivery-loader')?.classList.remove('hidden');
          window.location.reload();
        }
      }
      eraseCookie(COOKIE);
      if (getCookie(COOKIE_DISCOUNT) === DISCOUNT) {
        eraseCookie(COOKIE_DISCOUNT);
      }
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ discount: "" })
      });
    }
    if (cart.item_count < 2) {
      const cb = document.getElementById('consolidate-delivery');
      if (cb) cb.checked = false;
      removeShip()
    } else {
      const cb = document.getElementById('consolidate-delivery');
      const appliedDiscounts = cart.discount_codes || [];
      let deliveryUpdatedLoad = getCookie('deliveryUpdatedLoad') === 'false';
      if (hasGiftCard) {
        cb.checked = false;
      }
      if (cb && cb.checked) {
        if (appliedDiscounts.length === 0 && getCookie(COOKIE)) {
          window.location.href = `/discount/${DISCOUNT}?redirect=/cart`;
        }
      } else {
        let deliveryUpdated = false;
        if (cb && cb.checked == false && appliedDiscounts.some(d => d.code === DISCOUNT)) {
          
          deliveryUpdated = true;
          if (deliveryUpdated) {
            document.querySelector('.delivery-loader')?.classList.remove('hidden');
            removeShip()
            console.log('reload 2')
            window.location.reload();
          }
        }

      }
    }
  }

  window.removeShipIfLessThanTwo = removeShipIfLessThanTwo;
  document.addEventListener('DOMContentLoaded', removeShipIfLessThanTwo);
})();
